<script setup lang="ts">
import { computed } from 'vue';

import { cn } from '@/lib/utils';

const props = withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
    size?: 'sm' | 'md';
    type?: 'button' | 'submit';
    disabled?: boolean;
    loading?: boolean;
  }>(),
  { variant: 'secondary', size: 'md', type: 'button', disabled: false, loading: false },
);

const classes = computed(() =>
  cn(
    'inline-flex items-center justify-center gap-2 rounded-md font-medium transition',
    'disabled:cursor-not-allowed disabled:opacity-50',
    props.size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-3.5 py-2 text-sm',
    {
      primary: 'bg-brand-ink text-white hover:bg-stone-700',
      secondary: 'bg-white text-stone-800 ring-1 ring-stone-300 ring-inset hover:bg-stone-50',
      ghost: 'text-stone-600 hover:bg-stone-100 hover:text-stone-900',
      danger: 'bg-verdict-fail text-white hover:opacity-90',
    }[props.variant],
  ),
);
</script>

<template>
  <button :type="type" :class="classes" :disabled="disabled || loading">
    <span
      v-if="loading"
      class="size-3.5 animate-spin rounded-full border-2 border-current border-t-transparent"
      aria-hidden="true"
    />
    <slot />
  </button>
</template>
